import useSWR from "swr";
import fetcher from "../../lib/fetcher";
import { EUserType } from "../../interfaces";

export interface IUserResponseSchemaResponse {
  id: number;
  createdAt: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  patronymic?: string;
  phone: string;
  email?: string;
  type: EUserType;
}

interface IUserResponseSchemaResponseWrapper {
  data: IUserResponseSchemaResponse;
}

const useMe = () => {
  const { data, error, isLoading, mutate } = useSWR(
    `/user/me`,
    (url) => fetcher.swr<IUserResponseSchemaResponseWrapper>(url),
    { errorRetryCount: 0, revalidateOnFocus: false }
  );

  return {
    me: data?.data,
    error,
    isLoading,
    mutate,
  };
};

export default useMe;
